// Recommendation system routes
import RecommendationMatrixView from '../../views/RecommendationMatrixView.vue'
import Recommendations from '../../components/Recommendations.vue'
import PersonasManager from '../../components/Personas.vue'
import RecommendationPersonas from '../../components/RecommendationPersonas.vue'
import SimilarRecommendations from '../../components/SimilarRecommendations.vue'

export default [
  {
    path: '/recommendation-matrix',
    name: 'RecommendationMatrix',
    component: RecommendationMatrixView,
    meta: { 
      requiresAuth: true,
      title: 'Recommendation Matrix'
    }
  },
  {
    path: '/recommendations',
    name: 'Recommendations',
    component: Recommendations,
    meta: { 
      requiresAuth: true,
      title: 'Recommendations'
    }
  },
  {
    path: '/personas',
    name: 'Personas',
    component: PersonasManager,
    meta: { 
      requiresAuth: true,
      title: 'Personas'
    }
  },
  {
    path: '/recommendation-personas',
    name: 'RecommendationPersonas',
    component: RecommendationPersonas,
    meta: { 
      requiresAuth: true,
      title: 'Recommendation Personas'
    }
  },
  {
    path: '/similar-recommendations',
    name: 'SimilarRecommendations',
    component: SimilarRecommendations,
    meta: { 
      requiresAuth: true,
      title: 'Similar Recommendations'
    }
  }
] 